// getIsNewlyUnlockedMessage.js
'use strict';
import createCachedSelector from '../resource/createCachedSelector.js';

import getNetworkingData from '../selector/getNetworkingData.js';

/**
 * Selector to determine if a message is newly unlocked.
 * @kind selector
 * @param {Immutable.Map} state - The root Redux state.
 * @param {string} messageId - The message ID to check.
 * @returns {boolean} True if the message is newly unlocked, false if not.
 */
const getIsNewlyUnlockedMessage = createCachedSelector(
  (state, messageId) =>
    getNetworkingData(state, ['messages', messageId, 'unlock'], 'isFetched'),
  (state, messageId) =>
    getNetworkingData(state, ['messages', messageId, 'unlock'], 'error'),
  (isFetched, error) => {
    return isFetched && !error;
  }
)((state, messageId) => `${messageId}`);

export default getIsNewlyUnlockedMessage;
